module.exports = __webpack_public_path__ + "img/brinks.4e3740bb.png";